module.exports = __webpack_public_path__ + "img/index_smday.87192f65.png";